<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card class="border-primary">
          <b-card-body class="pb-0">
            <b-row>
              <b-col sm="4">
                <b-form-group>
                  <b-form-input type="number" placeholder="Links count" min="1" v-model="form.count"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <b-form-input type="number" placeholder="Price" min="1" v-model="form.price"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <b-form-select
                    :plain="true"
                    v-model="form.currency"
                    :options="currencyOptions">
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button type="submit" block variant="primary" @click="onPackageAdd()" :disabled="blocked"><span v-if="!blocked">Add</span><i class="fa fa-spinner" v-else></i></b-button>
            <hr class="my-4">
            <b-table responsive="sm" :items="packages" :fields="captions" fixed :current-page="currentPage" :per-page="perPage">
              <template slot="price" slot-scope="data">
                <span v-if="data.item.currency === 1">{{ data.item.price }} PLN</span>
                <span v-if="data.item.currency === 2">{{ data.item.price }} USD</span>
              </template>
              <template slot="actions" slot-scope="data">
                <b-button variant="danger" size="sm" class="mr-1" @click="onPackageDelete(data.item.id)">
                  Remove
                </b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Packages",
  data() {
    return {
      currencyOptions: [
        {
          text: "Currency",
          value: "",
          disabled: true,
          selected: true
        },
        {
          text: "PLN",
          value: 1
        },
        {
          text: "USD",
          value: 2
        }
      ],
      currentPage: 1,
      perPage: 25,
      packages: [],
      form: {
        count: "",
        price: "",
        currency: ""
      },
      captions: [
        { key: "id", sortable: true },
        { key: "count", sortable: true },
        { key: "price", sortable: true },
        { key: "actions", sortable: false }
      ],
      blocked: false
    };
  },
  methods: {
    loadPackages() {
      const that = this;

      Vue.axios({
        method: "GET",
        url: "/packages",
        mode: "no-cors",
        withCredentials: true,
        credentials: "same-origin"
      })
        .then(response => {
          if (response.data.status) {
            that.deny = response.data.deny;
            that.packages = response.data.packages;
          } else {
            Vue.swal(response.data.message, "", "warning");
          }
        })
        .catch(() => {
          Vue.swal("An unexpected error occurred", "", "warning");
        });
    },
    onPackageDelete(id) {
      const that = this;

      Vue.axios({
        method: "POST",
        url: "/admin/package/delete",
        data: {
          id
        },
        mode: "no-cors",
        withCredentials: true,
        credentials: "same-origin"
      })
        .then(response => {
          if (response.data.status) {
            Vue.swal("Package deleted!", "", "success");

            that.loadPackages();
          } else {
            Vue.swal(response.data.message, "", "warning");
          }
        })
        .catch(() => {
          Vue.swal("An unexpected error occurred", "", "warning");
        });
    },
    onPackageAdd() {
      this.blocked = true;

      const that = this;

      Vue.axios({
        method: "POST",
        url: "/admin/package/add",
        data: {
          count: this.form.count,
          price: this.form.price,
          currency: this.form.currency
        },
        mode: "no-cors",
        withCredentials: true,
        credentials: "same-origin"
      })
        .then(response => {
          if (response.data.status) {
            Vue.swal("Package saved!", "", "success");

            that.form.price = "";
            that.form.count = "";

            that.loadPackages();
          } else {
            Vue.swal(response.data.message, "", "warning");
          }
          that.blocked = false;
        })
        .catch(() => {
          Vue.swal("An unexpected error occurred", "", "warning");
          that.blocked = false;
        });
    },
    getRowCount() {
      return this.packages.length;
    }
  },
  beforeMount() {
    this.loadPackages();
  },
  computed: {
    totalRows() {
      return this.getRowCount();
    }
  }
};
</script>
